import React from "react";

export default function OptionsPrediction() {
  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-bold">
        AI Options Prediction
      </h1>

      <div className="rounded-xl border border-white/10 p-8">
        <h2 className="text-2xl font-semibold">
          Coming Soon
        </h2>

        <p className="text-white/60 mt-3">
          AI Options Prediction will analyze:
        </p>

        <ul className="list-disc ml-6 mt-4 space-y-2 text-white/70">
          <li>Call / Put Recommendation</li>
          <li>Strike Price Prediction</li>
          <li>Expiry Selection</li>
          <li>Probability of Profit</li>
          <li>Option Greeks</li>
          <li>IV Analysis</li>
        </ul>
      </div>
    </div>
  );
}
